'use client';

import { ISalePageDetailV2Response } from '@/api/types';
import { useSalePageQuery } from '@/entities/salePage';
import { useDeviceSize } from '@/hooks/useDeviceSize';
import { qaAttr } from '@/lib/qa';
import { Divider, Element } from '@vuddy/components';
import { ChannelInfoSection } from '../channel';
import { SalePageTopImages } from '../topImages';
import ClassSummaryContents from './ClassSummaryContents';
import * as styles from './summary.css';
import SummaryContents from './SummaryContents';

interface SalePageSummaryProps {
  salePageId?: number;
  salePage?: Partial<ISalePageDetailV2Response>;
  hidePurchaseCTAButton?: boolean;
  qaId?: string;
}

export const SalePageSummary = ({
  salePageId,
  salePage: salePageProp,
  hidePurchaseCTAButton = false,
  qaId,
}: SalePageSummaryProps) => {
  const deviceSize = useDeviceSize();
  const { data: salePageFromQuery } = useSalePageQuery(salePageId);

  // prop으로 받은 salePage가 있으면 사용, 없으면 query 결과 사용
  const salePage = salePageProp ?? salePageFromQuery;

  if (!salePage) return null;

  // 구매 버튼 숨김 여부 (desktop 일 때만, salePageId가 있을 때만 표시)
  const isShowSummaryCTA = Boolean(
    !hidePurchaseCTAButton && deviceSize !== 'mobile' && salePageId
  );

  // 클래스 여부
  const isClass = salePage?.type === 'CLASS';

  return (
    <Element className={styles.summary} {...(qaId ? qaAttr(qaId) : {})}>
      <SalePageTopImages salePage={salePage} />

      <Element className={styles.verticalDivider} />

      <Element className={styles.summaryContent}>
        {salePage?.channelUrl && (
          <Element className={styles.channelUrl}>
            <ChannelInfoSection
              channelUrl={salePage.channelUrl}
              salePageId={salePage.id!}
              salePageType={salePage.type!}
            />
          </Element>
        )}

        <Divider />

        {isClass ? (
          <ClassSummaryContents
            salePage={salePage}
            hidePurchaseCTAButton={hidePurchaseCTAButton}
            isShowSummaryCTA={isShowSummaryCTA}
            salePageId={salePageId}
          />
        ) : (
          <SummaryContents
            salePage={salePage}
            hidePurchaseCTAButton={hidePurchaseCTAButton}
            isShowSummaryCTA={isShowSummaryCTA}
            salePageId={salePageId}
          />
        )}
      </Element>
    </Element>
  );
};
